export { FrameMinimaps } from "./Minimap";